import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import validate from 'validate.js';
import Grid from '@material-ui/core/Grid';
import FormTextField from '../legacyForm/FormTextField';

const required = value => value ? undefined : 'Pole jest wymagane';
const email = value => validate.single(value, { email: true }) ? 'Ades nie jest prawidłowy' : undefined;
const phoneNumber = isOptional => value => {
  if (!value || /^\s*$/.test(value)) {
    if (!isOptional) return 'Pole jest wymagane';
    return undefined;
  }

  if (!/^\s*(\d\s*){9}$/.test(value)) return 'Numer telefonu musi składać się z 9 cyfr';
  return undefined;
};

const phoneNumberOptional = phoneNumber(true);
const phoneNumberRequired = phoneNumber(false);

const ApplicantDataLegalEntity = ({ voterRequiredData, readonly }) => (
  <div>
    {voterRequiredData.fullName && <div><Field
      name="voter.fullName"
      component={FormTextField}
      label="Nazwa"
      fullWidth
      validate={voterRequiredData.fullNameOptional ? undefined : required}
      disabled={readonly}
    /></div>}
    {voterRequiredData.address && <div><Field
      name="voter.address"
      component={FormTextField}
      label="Adres"
      fullWidth
      validate={voterRequiredData.addressOptional ? undefined : required}
      disabled={readonly}
    /></div>}
    {voterRequiredData.nip && <div><Field
      name="voter.nip"
      component={FormTextField}
      label="Numer NIP"
      validate={voterRequiredData.nipOptional ? undefined : required}
      disabled={readonly}
    /></div>}
    {voterRequiredData.krs && <div><Field
      name="voter.krs"
      component={FormTextField}
      label="Numer KRS"
      validate={voterRequiredData.krsOptional ? undefined : required}
      disabled={readonly}
    /></div>}
    {voterRequiredData.regon && <div><Field
      name="voter.regon"
      component={FormTextField}
      label="Numer REGON"
      validate={voterRequiredData.regonOptional ? undefined : required}
      disabled={readonly}
    /></div>}
    <Grid container spacing={1}>
      {voterRequiredData.phoneNumber && <Grid item xs><Field
        name="voter.phoneNumber"
        component={FormTextField}
        label="Numer telefonu"
        validate={voterRequiredData.phoneNumberOptional ? phoneNumberOptional : phoneNumberRequired}
        disabled={readonly}
      /></Grid>}
      {voterRequiredData.email && <Grid item xs><Field
        name="voter.email"
        component={FormTextField}
        label="Adres e-mail"
        type="email"
        validate={voterRequiredData.emailOptional ? email : [required, email]}
        disabled={readonly}
      /></Grid>}
    </Grid>
    {voterRequiredData.contactPersonData && <div><Field
      name="voter.contactPersonData"
      component={FormTextField}
      label="Dane osoby kontaktowej"
      fullWidth
      validate={voterRequiredData.contactPersonDataOptional ? undefined : required}
      disabled={readonly}
    /></div>}
  </div>
);

ApplicantDataLegalEntity.propTypes = {
  voterRequiredData: PropTypes.object.isRequired,
  readonly: PropTypes.bool,
};

export default ApplicantDataLegalEntity;



// WEBPACK FOOTER //
// ./src/components/budget/ApplicantDataLegalEntity.js